import { MultiLanguage } from "../../MultiLanguage";
import { FilePropertiesValidation } from "../../FilePropertiesValidation";

export class CreditableExam {
    private _id: string;
    private _description: MultiLanguage;
    private _creditable: boolean;
    private _creditableDescription: MultiLanguage;
    private _order: number;
    private _fileProperties: any;

    constructor(data: any) {
        this._id = data.id;
        this._description = new MultiLanguage(data.description);
        this._creditable = data.creditable;
        this._creditableDescription = new MultiLanguage(data.creditableDescription);
        this._order = data.order;
        this._fileProperties = new FilePropertiesValidation();
    }

    public get id(): string {
        return this._id;
    }
    public get description(): MultiLanguage {
        return this._description;
    }
    public get creditable() {
        return this._creditable;
    }
    public get creditableDescription() {
        return this._creditableDescription;
    }
    public get order() {
        return this._order;
    }
    public get fileProperties(): any{
        return this._fileProperties;
    }
    public set fileProperties(fileProperties: any){
        this._fileProperties = fileProperties;
    }

    public toServer() {
        return {
            id: this._id,
            description: this._description,
            creditable: this._creditable,
            creditableDescription: this._creditableDescription
        }
    }
}